import { WsgRequest } from '@src/app/_global/domain/WsgRequest';

export const UNAUTH_GET_IAM_KEYS = 'UNAUTH_GET_IAM_KEYS';
export const UNAUTH_IAM_KEYS_SUCCESS = 'UNAUTH_IAM_KEYS_SUCCESS';
export const AUTH_IAM_KEYS_SUCCESS = 'AUTH_IAM_KEYS_SUCCESS';
export const REFETCH_CUSTOMER_DATA = 'REFETCH_CUSTOMER_DATA';
export const FIND_SECURED_USER = 'FIND_SECURED_USER';

export type Actions = {
  UNAUTH_GET_IAM_KEYS: { type: typeof UNAUTH_GET_IAM_KEYS; payload: {} };
  UNAUTH_IAM_KEYS_SUCCESS: {
    type: typeof UNAUTH_IAM_KEYS_SUCCESS;
    payload: { identityId: string; wsgPayload: WsgRequest };
  };
  AUTH_IAM_KEYS_SUCCESS: {
    type: typeof AUTH_IAM_KEYS_SUCCESS;
    payload: { credentials: any; wsgPayload: WsgRequest };
  };
  REFETCH_CUSTOMER_DATA: {
    type: typeof REFETCH_CUSTOMER_DATA;
    payload: any;
  };
  FIND_SECURED_USER: {
    type: typeof FIND_SECURED_USER;
    payload: any;
  };
};

// Action Creators
export const actionCreators = {
  unauthGetIamKeys: (
    request: WsgRequest,
  ): Actions[typeof UNAUTH_GET_IAM_KEYS] => ({
    type: UNAUTH_GET_IAM_KEYS,
    payload: request,
  }),
  unauthIamKeysSuccess: (
    identityId: string,
    lookupPayload: WsgRequest,
  ): Actions[typeof UNAUTH_IAM_KEYS_SUCCESS] => ({
    type: UNAUTH_IAM_KEYS_SUCCESS,
    payload: { identityId: identityId, wsgPayload: lookupPayload },
  }),
  authIamKeysSuccess: (
    credentials: any,
    lookupPayload: WsgRequest,
  ): Actions[typeof AUTH_IAM_KEYS_SUCCESS] => ({
    type: AUTH_IAM_KEYS_SUCCESS,
    payload: { credentials: credentials, wsgPayload: lookupPayload },
  }),
  refetchCustomer: (payload: any): Actions[typeof REFETCH_CUSTOMER_DATA] => ({
    type: REFETCH_CUSTOMER_DATA,
    payload,
  }),
  findMyloUser: (payload: any, credentials: any, lookupType: any): Actions[typeof FIND_SECURED_USER] => ({
    type: FIND_SECURED_USER,
    payload: { payload, credentials, lookupType },
  }),
};
